import Page from "../../components/Page";
import useAssessmentsList from "./hooks/useAssessmentsList";

const AssessmentsList = () => {
  const page = useAssessmentsList();
  return <Page {...page} />;
};

export default AssessmentsList;
